export interface IOnboardingSettings {
  onboardingTipsState: string[]
  onboardingChecklistClosedPermanently: boolean
  onboardingChecklistCollapsed: boolean
  atLeastOneProjectHasBeenCreated: boolean
  webinarWidget: string
  connectProjectWidgetPermanentlyClosed: boolean
  isDashboardOnboardingTasksWidgetClosedPermanently: boolean
  connectGiftProjectRedeemed: boolean
  connectGiftProjectDeclined: boolean
  isOnboardingSurveyCompleted: boolean
  subscriptionActivatedOn: string | undefined
}

export const defaultOnboardingSettings: IOnboardingSettings = {
  onboardingTipsState: [],
  onboardingChecklistClosedPermanently: false,
  onboardingChecklistCollapsed: false,
  atLeastOneProjectHasBeenCreated: false,
  webinarWidget: undefined,
  connectProjectWidgetPermanentlyClosed: false,
  isDashboardOnboardingTasksWidgetClosedPermanently: false,
  connectGiftProjectRedeemed: false,
  connectGiftProjectDeclined: false,
  isOnboardingSurveyCompleted: false,
  subscriptionActivatedOn: undefined
}
